import { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';
import { VERIFICATION_DEADLINE } from '../../../lib/verificationStatus';
import { Button } from '../../Button';
import { Checkbox } from '../../Checkbox';
import * as ConfirmationTable from '../ConfirmationTable';
import { FormData } from './FormData';

interface Props {
  className?: string;
  formData: FormData;
  onContinue?(): void;
  onBack?(): void;
  completeVerificationNow?: boolean;
  onCompleteVerificationChange?(value: boolean): void;
  submitting?: boolean;
}

export function ConfirmIndividualDetails(props: Props) {
  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onCompleteVerificationChange?.(event.target.checked);
  };

  return (
    <div className={twMerge(props.className)}>
      <div className="text-3xl text-white font-semibold text-center">
        Thank you for registering for the Publishing Portal!
      </div>
      <div className="mt-16">
        <div className="text-sm text-white font-bold mb-2">
          Company Information
        </div>
        <div className="space-y-1">
          <ConfirmationTable.Row>
            <ConfirmationTable.Item label="type">
              Individual
            </ConfirmationTable.Item>
          </ConfirmationTable.Row>
          <ConfirmationTable.Row>
            <ConfirmationTable.Item label="Name">
              {props.formData.name}
            </ConfirmationTable.Item>
          </ConfirmationTable.Row>
          <ConfirmationTable.Row>
            <ConfirmationTable.Item label="Website">
              {props.formData.website}
            </ConfirmationTable.Item>
          </ConfirmationTable.Row>
        </div>
      </div>
      <label className="mt-10 flex items-center gap-3 text-sm text-white leading-tight cursor-pointer">
        <span className="flex items-center">
          <Checkbox
            checked={props.completeVerificationNow ?? false}
            onChange={handleCheckboxChange}
          />
        </span>
        <span>
          Complete identity verification now ({VERIFICATION_DEADLINE})
        </span>
      </label>
      <div className="mt-16 flex items-center gap-x-4">
        {props.onBack && (
          <Button
            className="w-1/4 bg-transparent border-white/20 text-white hover:bg-white/10 focus:bg-white/10 active:bg-white/20"
            onClick={props.onBack}
          >
            Back
          </Button>
        )}
        <Button
          className="w-3/4"
          onClick={props.onContinue}
          submitting={props.submitting}
          disabled={props.submitting}
        >
          Confirm details
        </Button>
      </div>
    </div>
  );
}
